function PresentIcon() {
	return (
		<svg
			width="80"
			height="81"
			viewBox="0 0 80 81"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				opacity="0.5"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M44.5783 0.264184C55.7569 0.180374 68.2956 2.7406 74.6533 11.9356C80.5851 20.5146 74.4255 31.6269 73.4429 42.0106C72.6206 50.7017 74.7173 59.9212 69.4537 66.8859C63.5585 74.6863 54.3398 79.6446 44.5783 80.2039C34.2904 80.7933 24.2668 76.8822 16.6794 69.9095C8.75335 62.6257 3.34064 52.7702 3.01736 42.0106C2.68497 30.9475 7.14209 20.2269 14.951 12.3832C22.7769 4.52237 33.4864 0.347344 44.5783 0.264184Z"
				fill="#C8E4FF"
			/>
			<g clipPath="url(#clip0_326_73689)">
				<path
					d="M59.5861 36.7153V56.1326C59.5861 58.5451 57.63 60.5007 55.2171 60.5007H24.7811C22.3682 60.5007 20.4121 58.545 20.4121 56.1326V36.7153"
					stroke="#2E7FDB"
					strokeWidth="2.5"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<g opacity="0.5">
					<path
						d="M35.5078 36.9236V59.6543"
						stroke="#2E7FDB"
						strokeWidth="2.5"
						strokeMiterlimit="10"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M35.5078 29.6863V35.0972"
						stroke="#2E7FDB"
						strokeWidth="2.5"
						strokeMiterlimit="10"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M44.4922 35.1292V29.6863"
						stroke="#2E7FDB"
						strokeWidth="2.5"
						strokeMiterlimit="10"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M44.4922 59.6559V36.8953"
						stroke="#2E7FDB"
						strokeWidth="2.5"
						strokeMiterlimit="10"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M44.4385 28.1009L49.0724 25.3621"
						stroke="#2E7FDB"
						strokeWidth="2.5"
						strokeMiterlimit="10"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M35.5637 28.1009L30.9297 25.3621"
						stroke="#2E7FDB"
						strokeWidth="2.5"
						strokeMiterlimit="10"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M23.4326 28.2947L25.3601 23.4447C26.3431 20.9713 29.1882 19.8227 31.6067 20.9231L32.2502 21.2159C34.6057 22.2876 36.1185 24.6413 36.1185 27.2345"
						stroke="#2E7FDB"
						strokeWidth="2.5"
						strokeMiterlimit="10"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M56.5146 28.1611L54.6402 23.4447C53.6572 20.9713 50.8121 19.8227 48.3936 20.9231L47.7501 21.2159C45.3946 22.2876 43.8818 24.6413 43.8818 27.2345"
						stroke="#2E7FDB"
						strokeWidth="2.5"
						strokeMiterlimit="10"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M36.1191 28.098V26.8572C36.1191 24.7139 37.857 22.9763 40.0008 22.9763C42.1445 22.9763 43.8824 24.7138 43.8824 26.8572V28.098"
						stroke="#2E7FDB"
						strokeWidth="2.5"
						strokeMiterlimit="10"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</g>
				<path
					d="M62.9688 28.8428H17.0312V35.9677H62.9688V28.8428Z"
					stroke="#2E7FDB"
					strokeWidth="2.5"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_326_73689">
					<rect
						width="48"
						height="48"
						fill="white"
						transform="translate(16 16.5)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
}

export default PresentIcon;
